import fetchServer from "../fetchServer";

export default async function getTaxes(cancelToken) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching tax data!",
  };

  let props = {}
  if(cancelToken)
    props.cancelToken = cancelToken

  await fetchServer({
    method: "GET",
    url: `/product/v1/tax`,
    ...props
  })
    .then((res) => {
      if (res) {
        if (res.status >= 200 && res?.status < 300) {
          result = { return: 1, msg: "Successfull", data: res.data.data || [] };
        }
        else if (res?.data?.error) {
          result["msg"] = res.data.error
        };
      }
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
